import http from "@/http";

export default {
  login(context, credentials) {
    return new Promise((resolve, reject) => {
      http
        .post("/auth/login", credentials)
        .then(response => {
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("role", response.data.user.role);
          localStorage.setItem("user", response.data.user._id);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
